/** Základní barvy tématu Erma*/
export const SemanticColors = {
  surface: {
    50: 'var(--erma-slate-50)',
    100: 'var(--erma-slate-100)',
    200: 'var(--erma-slate-200)',
    300: 'var(--erma-slate-300)',
    400: 'var(--erma-slate-400)',
    500: 'var(--erma-slate-500)',
    600: 'var(--erma-slate-600)',
    700: 'var(--erma-slate-700)',
    800: 'var(--erma-slate-800)',
    900: 'var(--erma-slate-900)',
    950: 'var(--erma-slate-950)'
  },
  primary: {
    0: '#ffffff',
    50: '#e6f4eb',
    100: '#b3e0c4',
    200: '#80cc9e',
    300: '#4db878',
    400: '#26a75a',
    500: '#007438', // Hlavní barva
    600: '#00632f',
    700: '#005127',
    800: '#00411d',
    900: '#003014',
    950: '#001c0a'
  },
  secondary: {
    0: '#ffffff',
    20: '#f9f9f9',
    40: '#f4f4f4',
    50: '#f2f2f2',
    100: '#e6e6e6',
    200: '#cccccc',
    220: '#c8c8c8',
    300: '#b3b3b3',
    350: '#a6a6a6',
    400: '#999999',
    480: '#848484',
    500: '#808080',
    600: '#666666',
    700: '#4d4d4d',
    800: '#333333',
    870: '#212121',
    900: '#1a1a1a',
    950: '#0d0d0d',
    1000: '#000000'
  }
};
